"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalBackground = exports.StyledModal = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const backgroundOpacity = "0.6";
const backgroundAnimationLength = "300ms";
const initialPosition = "50px";
const animationLength = "300ms";
const StyledModalBackground = _styledComponents.default.div`
  background-color: rgba(0, 20, 29, 0.6);
  bottom: 0;
  left: 0;
  opacity: ${backgroundOpacity};
  position: fixed;
  right: 0;
  top: 0;

  ${({
  transitionName
}) => (0, _styledComponents.css)`
    &.${transitionName}-enter, .${transitionName}-appear {
      opacity: 0;
    }

    &.${transitionName}-enter.${transitionName}-enter-active,
      &.${transitionName}-appear.${transitionName}-appear-active {
      opacity: ${backgroundOpacity};
      transition: opacity ${backgroundAnimationLength} ease-out;
    }

    &.${transitionName}-exit {
      opacity: ${backgroundOpacity};
    }

    &.${transitionName}-exit.${transitionName}-exit-active {
      opacity: 0;
      transition: opacity ${backgroundAnimationLength} 100ms ease-out;
    }
  `}
`;
exports.StyledModalBackground = StyledModalBackground;
const StyledModal = _styledComponents.default.div`
  ${({
  transitionName
}) => (0, _styledComponents.css)`
    .${transitionName}-enter, .${transitionName}-appear {
      opacity: 0;
      margin-top: ${initialPosition};
    }

    .${transitionName}-enter.${transitionName}-enter-active,
      .${transitionName}-appear.${transitionName}-appear-active {
      opacity: 1;
      margin-top: 0;
      transition: all ${animationLength} 100ms ease-out;
    }

    .${transitionName}-exit {
      opacity: 1;
      margin-top: 0;
    }

    .${transitionName}-exit.${transitionName}-exit-active {
      opacity: 0;
      margin-top: ${initialPosition};
      transition: all ${animationLength} ease-out;
    }
  `}
`;
exports.StyledModal = StyledModal;